<template>
    <div class="sidebar">
        <SidebarHeader/>
        <nav class="sidebar-nav">
            <div slot="header"></div>
            <ul class="nav">
                <template v-for="item in navItems">
                    <template v-if="item.title">
                        <SidebarNavTitle :name="item.name" :classes="item.class" :wrapper="item.wrapper"/>
                    </template>
                    <template v-else-if="item.divider">
                        <li class="divider"></li>
                    </template>
                    <template v-else>
                        <template v-if="item.children && (!item.admin || (item.admin && isAdmin)) && (!item.franchisee || (item.franchisee && isFranchisee))">
                            <!-- First level dropdown -->
                            <SidebarNavDropdown :name="item.name" :url="item.url" :icon="item.icon">
                                <template v-for="childL1 in item.children">
                                    <template v-if="childL1.children">
                                        <!-- Second level dropdown -->
                                        <SidebarNavDropdown :name="childL1.name" :url="childL1.url"
                                                            :icon="childL1.icon">
                                            <li class="nav-item" v-for="childL2 in childL1.children">
                                                <SidebarNavLink :name="childL2.name" :url="childL2.url"
                                                                :icon="childL2.icon" :badge="childL2.badge"/>
                                            </li>
                                        </SidebarNavDropdown>
                                    </template>
                                    <template v-else>
                                        <li class="nav-item">
                                            <SidebarNavLink :name="childL1.name" :url="childL1.url" :icon="childL1.icon"
                                                            :badge="childL1.badge"/>
                                        </li>
                                    </template>
                                </template>
                            </SidebarNavDropdown>
                        </template>
                        <template v-else-if="!item.admin || (item.admin && isAdmin)">
                            <li class="nav-item">
                                <SidebarNavLink :name="item.name" :url="item.url" :icon="item.icon"
                                                :badge="item.badge"/>
                            </li>
                        </template>
                    </template>
                </template>
            </ul>
            <slot></slot>
        </nav>
        <SidebarFooter/>
    </div>
</template>
<script>
    import navigation from '@/navigation'
    import SidebarFooter from './SidebarFooter'
    import SidebarHeader from './SidebarHeader'
    import SidebarNavDropdown from './SidebarNavDropdown'
    import SidebarNavLink from './SidebarNavLink'
    import SidebarNavTitle from './SidebarNavTitle'

    export default {
        name: 'sidebar',
        data () {
            return {
                navItems: navigation.items
            }
        },
        computed: {
            isAdmin () {
                return this.$store.getters.isAdmin
            },
            isFranchisee () {
                return this.$store.getters.isFranchisee
            }
        },
        components: {
            SidebarFooter,
            SidebarHeader,
            SidebarNavDropdown,
            SidebarNavLink,
            SidebarNavTitle
        },
        methods: {
            handleClick (e) {
                e.preventDefault()
                e.target.parentElement.classList.toggle('open')
            }
        }
    }
</script>

<style lang="css">
    .nav-link {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?3649c2ad